(function() {
	'use strict';

	angular.module('FYN')
	.controller('MetaController', function($rootScope, $scope, PageService) {});
	
})();